import api from '../api';
import { token_keys } from '../constants';

const clearLocalTokens = () => {
  localStorage.removeItem(token_keys.access_token);
  localStorage.removeItem(token_keys.refresh_token);
  localStorage.removeItem(token_keys.expiration);
  localStorage.removeItem(token_keys.issued_at);
  localStorage.removeItem(token_keys.last_activity);
};

// Calls the unified logout endpoint and clears local tokens.
//
// Returns a federated end-session URL when the backend provides one (Entra
// users on a full logout); null otherwise (password / WorkOS users, or when
// localOnly is true). The caller decides what to do with it: navigate the
// browser there to also end the Microsoft session, or fall back to /login.
//
// localOnly: true keeps the Microsoft session alive ("stay signed in to
// Microsoft" / switch-account UX); the response then has no redirect_url.
export const performLogout = async ({ localOnly = false } = {}) => {
  const accessToken = localStorage.getItem(token_keys.access_token);
  let redirectUrl = null;
  try {
    const response = await api.logout(accessToken, localOnly);
    redirectUrl = response?.data?.redirect_url || null;
  } finally {
    // Always drop local credentials, even if the network call failed.
    clearLocalTokens();
  }
  return redirectUrl;
};
